export default __webpack_public_path__ + "static/media/startAndStopPO.0bf27d0f.svg";